export default "__VITE_ASSET__CVtlcD7z__"